module.exports = __webpack_public_path__ + "static/media/dpd.54fe3665.png";